/* eslint-disable prettier/prettier */
import React, {
  useRef,
  useCallback,
  useState,
  useEffect,
  useMemo,
} from 'react';

import { Form } from '@unform/web';
// import { Container } from './styles';
import { Button, Row, Col, Card } from 'react-bootstrap';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { FaPlusCircle, FaTrashAlt } from 'react-icons/fa';
import Decimal from 'decimal.js';
import { useAuth } from '../../../hooks/auth';

import { useToast } from '../../../hooks/toast';
import { useFormaPagamento } from '../../../hooks/formapagamento';
import api from '../../../services/api';

import SelectSync, { IOption } from '../../SelectSync';
import Loading from '../../Loading';
import InputMoney from '../../InputMoney';
import getValidationErrors from '../../../utils/getValidationErrors';
import { formatPrice, updateTimeToNow } from '../../../utils/funcoes';
import Desconto, { IDesconto } from '../Desconto';
import Modal from '../../Modal';
import getResponseErrors from '../../../utils/getResponseErrors';
import { useClinica } from '../../../hooks/clinica';


// interface IDadosCancelamento {
//   PagCanUsuCodigo: number;
//   PagCanMotCodigo: number;
//   PagCanMotivo: string;
//   PagCanUsuNome: string;
//   DataAtualizacaoAgenda: string;
// }

interface IFormProps extends FormHandles {
  CprFormaPag: number;
  CprValorPag: number;
  CprDataPag: Date;
}

interface IFormaPagamento {
  BanCodigo: number;
  BanNome: string;
  BanSaldo?: number;
  BanTipo?: boolean;
  BanAtivo?: boolean;
}

interface IAlterarFormaPagamento {
  CprCodigo: number;
  CprFormaPag: number;
  CprValorPag: number;
  CprUsuCodigo: number;
  CprDesMotCodigo?: number;
  CprDesMotivo?: string;
  CprDesUsuCodigo?: number;
  pagamento: IPagamento[];
}

interface IPagamento {
  PagCodigo?: number;
  PagCprCodigo?: number;
  PagFormaPag: number;
  PagData: Date;
  PagValor: number;
  PagExcluido?: boolean;
  PagConferido?: boolean;
  PagCanUsuCodigo?: number;
  PagCanMotCodigo?: number;
  PagCanMotivo?: string;
  formaDePagamento?: IFormaPagamento;
  valorFormatado?: string;
}

type Props = {
  cprCodigo: number;
  CprValor: number;
  estaPago: boolean;
  ehTroco: boolean;
  ehSangria: boolean;
  EhConvenio?: boolean;
  ehDespesaOuOutrasReceitas: boolean;
  ehAlteracao?: boolean;
  dadosBaixa?: { nome?: string; data?: string; alteracao?: string };
  pagamentosRealizados: IPagamento[];
  descontoAplicado: IDesconto;
  handleAddedPagamento(dados: IPagamento[]): void;
  handleAddedDesconto(dados: IDesconto): void;
  handleFechar(): void;
  pegaValor(): number | undefined;
  apenasUmaForma?: boolean;
};

const FormaPagamento: React.FC<Props> = ({
  cprCodigo,
  CprValor,
  estaPago,
  ehAlteracao,
  dadosBaixa,
  ehDespesaOuOutrasReceitas,
  ehTroco = false,
  ehSangria = false,
  EhConvenio,
  pagamentosRealizados,
  descontoAplicado,
  handleAddedPagamento,
  handleAddedDesconto,
  handleFechar,
  pegaValor,
  apenasUmaForma = false,
}) => {
  const formRefFormaPagamento = useRef<IFormProps>(null);
  const { addToast } = useToast();
  const { user } = useAuth();
  const { dataHoraServidor } = useClinica();
  const {
    optionsFormasPagamentoTipo1,
    buscaFormaPagamento,
  } = useFormaPagamento();

  const [optionsFormaPagamento, setOptionsFormaPagamento] = useState<IOption[]>(
    [],
  );

  const [showModalDesconto, setShowModalDesconto] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (
      !optionsFormasPagamentoTipo1 ||
      Object.keys(optionsFormasPagamentoTipo1).length === 0
    )
      buscaFormaPagamento();
  }, [buscaFormaPagamento, optionsFormasPagamentoTipo1]);

  useEffect(() => {
    if (optionsFormasPagamentoTipo1.optionFormaPagamento)
      setOptionsFormaPagamento(
        optionsFormasPagamentoTipo1.optionFormaPagamento.filter(
          op => op.label.toUpperCase() !== 'CONVÊNIO',
        ),
      );
  }, [optionsFormasPagamentoTipo1.optionFormaPagamento]);

  useEffect(() => {
    if (EhConvenio && optionsFormasPagamentoTipo1.optionFormaPagamento) {
      const formaPag = optionsFormasPagamentoTipo1.optionFormaPagamento.find(
        op => op.label.toUpperCase() === 'CONVÊNIO',
      );

      if (!formaPag) return;

      const pags = pagamentosRealizados.find(
        pg =>
          pg.PagFormaPag === Number(formaPag.value) && pg.PagValor === CprValor,
      );

      if (!pags)
        handleAddedPagamento([
          {
            PagCprCodigo: cprCodigo,
            PagFormaPag: Number(formaPag.value),
            PagData: updateTimeToNow(new Date(dataHoraServidor.toString())),
            PagValor: CprValor,
            formaDePagamento: {
              BanCodigo: Number(formaPag.value),
              BanNome: formaPag.label,
            },
            valorFormatado: formatPrice(CprValor),
          },
        ]);
    }
  }, [
    CprValor,
    EhConvenio,
    handleAddedPagamento,
    cprCodigo,
    optionsFormasPagamentoTipo1,
    pagamentosRealizados,
    dataHoraServidor,
  ]);

  const total = useMemo(() => {
    const valor = pagamentosRealizados.reduce((tot, pag) => {
      return tot + Number(pag.PagValor);
    }, 0);
    return {
      valor,
      valorFormatado: formatPrice(valor),
    };
  }, [pagamentosRealizados]);

  const totalDesconto = useMemo(() => {
    return {
      valor: Number(descontoAplicado.valor),
      valorFormatado: formatPrice(-1 * Number(descontoAplicado.valor)),
    };
  }, [descontoAplicado.valor]);

  const resta = useMemo(() => {
    const valorDigitado = CprValor > 0 ? CprValor : pegaValor() || 0;
    const soma = new Decimal(valorDigitado)
      .minus(total.valor)
      .minus(totalDesconto.valor)
      .toDecimalPlaces(2)
      .toNumber();
    return {
      valor: soma,
      valorFormatado: formatPrice(soma),
    };
  }, [total.valor, totalDesconto.valor, CprValor, pegaValor]);

  const validaDadosPagamento = useCallback(
    async (dadosForm): Promise<boolean> => {
      try {
        formRefFormaPagamento.current?.setErrors({});

        const schemaPadrao = Yup.object().shape({
          CprFormaPag: Yup.number()
            .typeError('Selecione a forma de pagamento')
            .required('Valor requerido'),

          CprValorPag: Yup.number()
            .min(0.01, 'valor tem que ser maior que 0')
            .typeError('Valor incorreto')
            .required('Valor requerido'),
        });

        await schemaPadrao.validate(dadosForm, {
          abortEarly: false,
        });
        return true;
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefFormaPagamento.current?.setErrors(errors);
        }
        return false;
      }
    },
    [],
  );

  const handleAddPagamento = useCallback(async () => {
    const valido = await validaDadosPagamento(
      formRefFormaPagamento.current?.getData(),
    );

    if (!valido) return;
    const cprFormaPag = formRefFormaPagamento.current?.getFieldValue(
      'CprFormaPag',
    );

    const cprValorPag = formRefFormaPagamento.current?.getFieldValue(
      'CprValorPag',
    );
    const cprDataPag = formRefFormaPagamento.current?.getFieldValue(
      'CprDataPag',
    );

    const pagamentoSelecionado = optionsFormaPagamento.filter(
      pag => pag.value === String(cprFormaPag),
    );

    if (!pagamentoSelecionado[0]) return;
    if (pagamentoSelecionado[0].isDisabled) return;

    const valorDigitado = CprValor > 0 ? CprValor : pegaValor() || 0;

    const valoresAtuais = new Decimal(total.valor)
      .plus(new Decimal(totalDesconto.valor))
      .plus(new Decimal(cprValorPag))
      .toDecimalPlaces(2)
      .toNumber();
    const valorPassouDoTotal =
      valoresAtuais > valorDigitado;
    if (valorPassouDoTotal) {
      addToast({
        title: 'Valor digitado maior que o total.',
        type: 'error',
      });
      return;
    }

    handleAddedPagamento([
      ...pagamentosRealizados,
      {
        PagCprCodigo: cprCodigo,
        PagFormaPag: cprFormaPag,
        PagData:
          cprDataPag || updateTimeToNow(new Date(dataHoraServidor.toString())),
        PagValor: cprValorPag,
        formaDePagamento: {
          BanCodigo: cprFormaPag,
          BanNome: pagamentoSelecionado[0].label,
        },
        valorFormatado: formatPrice(cprValorPag),
      },
    ]);

    setOptionsFormaPagamento(state =>
      state.map(opt => {
        return {
          ...opt,
          isDisabled: opt.isDisabled
            ? opt.isDisabled
            : opt.value === cprFormaPag,
        };
      }),
    );
    formRefFormaPagamento.current?.setFieldValue('CprValorPag', '');
  }, [
    CprValor,
    optionsFormaPagamento,
    cprCodigo,
    validaDadosPagamento,
    addToast,
    total.valor,
    totalDesconto.valor,
    handleAddedPagamento,
    pagamentosRealizados,
    pegaValor,
    dataHoraServidor,
  ]);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => { }, []);

  const handleSalvaDesconto = useCallback(
    data => {
      handleAddedDesconto(data);
      setShowModalDesconto(false);
    },
    [handleAddedDesconto],
  );

  const fechouTotal = useMemo(() => {
    if (!CprValor) return true;
    return total.valor === Number(CprValor);
  }, [CprValor, total.valor]);

  const handleRemovePagamento = useCallback(
    PagFormaPag => {
      const pagamentoAtual = pagamentosRealizados.filter(
        pags => pags.PagFormaPag !== PagFormaPag,
      );

      setOptionsFormaPagamento(state =>
        state.map(opt => {
          return {
            ...opt,
            isDisabled: opt.isDisabled
              ? opt.isDisabled && opt.value !== PagFormaPag
              : opt.isDisabled,
          };
        }),
      );

      handleAddedPagamento(pagamentoAtual);
    },
    [pagamentosRealizados, handleAddedPagamento],
  );

  const handleAlterarFormaPagamento = useCallback(async () => {
    if (cprCodigo === 0) {
      addToast({
        type: 'error',
        title: 'Nenhum registro selecionado',
      });
      return;
    }
    if (formRefFormaPagamento.current) {
      if (resta.valor !== 0) {
        addToast({
          title: 'Confira os valores',
          description:
            'O total de valores informados são diferentes do total da parcela.',
          type: 'error',
        });

        return;
      }

      setLoading(true);

      const desconto =
        descontoAplicado.valor !== '0' && descontoAplicado.valor !== ''
          ? {
            CprDesUsuCodigo: descontoAplicado.UsuCodigo,
            CprDesMotCodigo: descontoAplicado.motivo,
            CprDesMotivo: descontoAplicado.descricao,
            CprDesconto: new Decimal(descontoAplicado.valor)
              .toDecimalPlaces(2)
              .toNumber(),
          }
          : {};

      const dataPagamento = updateTimeToNow(
        new Date(dataHoraServidor.toString()),
      );
      const pagamentos =
        pagamentosRealizados.length > 0
          ? pagamentosRealizados.map(pag => {
            return {
              PagData: dataPagamento,
              PagFormaPag: pag.PagFormaPag,
              PagValor: pag.PagValor,
            };
          })
          : [
            {
              PagData: dataPagamento,
              PagFormaPag: 9,
              PagValor: 0,
            },
          ];

      const CprFormaPag = pagamentos[0]?.PagFormaPag || 9;
      const DadosAtualizados: IAlterarFormaPagamento = {
        CprCodigo: cprCodigo,
        CprFormaPag,
        CprUsuCodigo: user.UsuCodigo,
        CprValorPag: total.valor,
        pagamento: pagamentos,
        ...desconto,
      };

      try {
        await api.post(
          `/caixa/alterarformapagamento/${cprCodigo}`,
          DadosAtualizados,
        );

        addToast({
          type: 'success',
          title: 'Alterado com sucesso',
        });
        if (ehAlteracao) handleFechar();
      } catch (error) {
        const mensagemErro = getResponseErrors(error);

        addToast({
          type: 'error',
          title: 'Erro ao alterar pagamento',
          description: mensagemErro,
        });
      }
      setLoading(false);
    }
  }, [
    cprCodigo,
    user.UsuCodigo,
    addToast,
    setLoading,
    total.valor,
    resta.valor,
    pagamentosRealizados,
    descontoAplicado,
    ehAlteracao,
    handleFechar,
    dataHoraServidor,
  ]);

  return (
    <>
      {showModalDesconto && (
        <Modal
          show={showModalDesconto}
          titulo="Desconto"
          handleFecharModal={() => setShowModalDesconto(false)}
          large={false}
        >
          {cprCodigo && (
            <Desconto
              valorParcela={CprValor || 0}
              handleFechar={() => setShowModalDesconto(false)}
              handleSalvar={handleSalvaDesconto}
              desconto={descontoAplicado}
            />
          )}
        </Modal>
      )}
      <div className={ehAlteracao ? 'container' : ''}>
        {loading && <Loading backgroundBlack={false} />}
        <Form
          ref={formRefFormaPagamento}
          onSubmit={() => console.log('submit')}
        >
          <div>
            <Row
              id="PanPags"
              className={`${estaPago || EhConvenio ? 'd-none' : ''}`}
            >
              <Col md="6" xl="6" className="form-group pr-2">
                <SelectSync
                  name="CprFormaPag"
                  label="Forma Pagamento"
                  placeholder="Selecione"
                  isClearable={false}
                  handleSelectChange={handleOnChangeVazio}
                  options={optionsFormaPagamento || { label: '', value: '' }}
                  isDisabled={pagamentosRealizados.length > 0 && apenasUmaForma}
                />
              </Col>
              <Col md="2" xl="2" className="form-group pr-2">
                <InputMoney
                  label="Valor"
                  name="CprValorPag"
                  autoComplete="nope"
                  placeholder="Valor"
                  disabled={pagamentosRealizados.length > 0 && apenasUmaForma}
                />
              </Col>
              <Col xl={1} md={1} style={{ paddingTop: '1px' }}>
                <Button
                  type="button"
                  style={{ marginTop: '18px' }}
                  size="sm"
                  variant="outline-info"
                  onClick={() => {
                    handleAddPagamento();
                  }}
                  disabled={pagamentosRealizados.length > 0 && apenasUmaForma}
                >
                  <FaPlusCircle />
                </Button>
              </Col>
              <Col xl={3} md={3} style={{ textAlign: 'end', paddingTop: '1px' }}>
                <Button
                  type="button"
                  variant="outline-success"
                  style={{ paddingTop: '0.1rem', paddingBottom: '0.1rem' }}
                  size="sm"
                  className={
                    descontoAplicado.motivo === 0 &&
                      CprValor !== 0 &&
                      !ehDespesaOuOutrasReceitas &&
                      !fechouTotal
                      ? 'btn btn-sm btn-outline-success mt-3 p-1'
                      : 'd-none'
                  }
                  onClick={() => setShowModalDesconto(true && !fechouTotal)}
                >
                  Adicionar Desconto
                </Button>
              </Col>
            </Row>
          </div>
        </Form>

        {((pagamentosRealizados && pagamentosRealizados.length > 0) ||
          descontoAplicado.motivo !== 0) && (
            <>
              <Row>
                <Col xl={estaPago ? 7 : 12} md={estaPago ? 7 : 12}>
                  <Row className="mt-2">
                    <Col xl={8} md={8}>
                      Forma de pagamento
                    </Col>
                    <Col xl={3} md={3}>
                      Valor
                    </Col>
                    <Col xl={1} md={1} />
                  </Row>

                  {pagamentosRealizados.map(pags => (
                    <Row
                      className="align-items-center border-bottom py-1"
                      key={`pagamento-${pags.PagCodigo
                        ? pags.PagCodigo.toString()
                        : 111111111 * Math.random()
                        }`}
                    >
                      <Col xl={8} md={8}>
                        {pags.formaDePagamento?.BanNome}
                      </Col>
                      <Col xl={3} md={3}>
                        {pags.valorFormatado}
                      </Col>
                      <Col xl={1} md={1}>
                        {!estaPago && !EhConvenio && (
                          <Button
                            type="button"
                            variant="outline-danger"
                            size="sm"
                            className="py-0"
                            onClick={() => {
                              handleRemovePagamento(pags.PagFormaPag);
                            }}
                          >
                            <FaTrashAlt />
                          </Button>
                        )}
                      </Col>
                    </Row>
                  ))}
                  <Row
                    className={`align-items-center border-bottom py-1 text-danger ${descontoAplicado.motivo !== 0 ? '' : 'd-none'
                      }`}
                  >
                    <Col md={8}>
                      <span title={descontoAplicado.descricao}>Desconto</span>
                    </Col>
                    <Col xl={3} md={3}>
                      {totalDesconto.valorFormatado}
                    </Col>
                    <Col xl={1} md={1}>
                      {!estaPago && (
                        <Button
                          type="button"
                          variant="outline-danger"
                          size="sm"
                          className="py-0"
                          onClick={() => {
                            handleAddedDesconto({
                              UsuCodigo: 0,
                              UsuNome: '',
                              descricao: '',
                              login: '',
                              motivo: 0,
                              valor: '0',
                            });
                          }}
                        >
                          <FaTrashAlt />
                        </Button>
                      )}
                    </Col>
                  </Row>
                  <Row className="align-items-center py-2">
                    <Col md={8}>
                      <b>Valor Total</b>
                    </Col>
                    <Col xl={3} md={3}>
                      <b>{total.valorFormatado}</b>
                    </Col>
                    <Col xl={1} md={1}>
                      &nbsp;
                    </Col>
                  </Row>
                  <Row
                    className={`py-2 border-top ${estaPago || resta.valor === 0 ? 'd-none' : ''
                      }`}
                  >
                    <Col md={9}>
                      <b>Resta</b>
                    </Col>
                    <Col xl={3} md={3}>
                      <b>{resta.valorFormatado}</b>
                    </Col>
                  </Row>
                </Col>
                <Col
                  xl={5}
                  md={5}
                  className={`pr-0 ${estaPago && dadosBaixa?.nome ? '' : 'd-none'
                    }`}
                >
                  <Card>
                    <Card.Header as="h5">Informações da Baixa</Card.Header>
                    <Card.Body>
                      <Card.Text>
                        <b>Data Baixa:</b> {dadosBaixa?.data}
                        <br />
                        <b>Usuário:</b> {dadosBaixa?.nome}
                        <br />
                        <b>Ult. Alteração:</b> {dadosBaixa?.alteracao}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        <Row className={!ehAlteracao ? 'd-none' : ''}>
          <Col md="12" xl="12">
            <Button
              type="button"
              variant="success"
              style={{ paddingTop: '0.1rem', paddingBottom: '0.1rem' }}
              size="sm"
              className="btn btn-sm btn-success mx-1"
              onClick={handleAlterarFormaPagamento}
            >
              Salvar
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default FormaPagamento;
